// Демо-состояния прохождения теста (`?demo=`) — ОДИН источник для схемы
// search-параметров роута и для пропа встроенного движка. Это не мёртвый код:
// им показывают состояния при ревью UI (см. `docs/ui-spec/quizzes.take.*`).
export const QUIZ_TAKE_DEMOS = [
	"loading",
	"generating",
	"error",
	"time-up",
	"grading",
	"paywall",
	"resume",
] as const;

export type QuizTakeDemo = (typeof QUIZ_TAKE_DEMOS)[number];
